import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { data } from 'jquery';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-cyot-share-options',
  templateUrl: './cyot-share-options.component.html',
  styleUrls: ['./cyot-share-options.component.css']
})
export class CyotShareOptionsComponent implements OnInit {
public rooturl:any;
public testData:any;
showCoupon:boolean = false;
  constructor(@Inject(DOCUMENT) private document: Document,
              @Inject(MAT_DIALOG_DATA) public data: any) 
  {
    this.testData = data;
    this.testData.ruleId = btoa(this.testData.ruleId);
  }

  ngOnInit(): void {
    this.rooturl = this.document.location.origin;
  }
  
  copyShareUrl(shareUrlinput) {
    var copyText : any = shareUrlinput;
    this.showCoupon = !this.showCoupon;
    setTimeout(()=>
    {
      this.showCoupon=false
    }
      , 3000);
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */
    navigator.clipboard.writeText(copyText.value);
    
  }

}
